import { render, staticRenderFns } from "./AlleleFrequencyChart.vue?vue&type=template&id=6f33ae77&scoped=true&"
import script from "./AlleleFrequencyChart.vue?vue&type=script&lang=js&"
export * from "./AlleleFrequencyChart.vue?vue&type=script&lang=js&"
import style0 from "./AlleleFrequencyChart.vue?vue&type=style&index=0&id=6f33ae77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f33ae77",
  null
  
)

export default component.exports